import imageComponentHtml from './imageComponent.html';
import './imageComponent.css';

export function imageComponent() {
	return {
		restrict: 'E',
		bindings: {
			src: '@',
			displayWidth: '@',
			displayHeight: '@',
			alt: '@',
			onLoad: '&?',
			onError: '&?',
		},
		controllerAs: 'vm',
		controller: imageComponentCtrl,
		template: imageComponentHtml,
	};
}

class imageComponentCtrl {
	constructor($element, $timeout) {
		'ngInject';
		this.$element = $element;
		this.$timeout = $timeout;
		this.emptyGif = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D';
	}

	$onInit() {
		if (this.src.match(/^file:/i)) {
			// Avoid double "pin" geometry for mobile app
			this.src = this.src.replace(/\.pin-[0-9]+\.jpg/, '');
		}
		const img = this.$element[0].querySelector('img');
		if (!img) {
			console.error('sh-image unable to find the <img> element specified in the angular template');
		}
		img.addEventListener('load', $event => {
			img.classList.add('loaded');
			this.onLoad && this.$timeout(() => this.onLoad({ $event }));
		});
		img.addEventListener('error', $event => {
			img.classList.add('errored');
			img.src = this.emptyGif;
			this.onError && this.$timeout(() => this.onError({ $event }));
		});
	}
}
